export const enum ContentType {
  BYTES = "application/octet-stream",
  HTML = "text/html",
  JSON = "application/json",
  JPEG = "image/jpeg",
  PDF = "application/pdf",
  PNG = "image/png",
  TEXT = "text/plain",
  TIFF = "image/tiff",
  WASM = "application/wasm",
  WEBP = "image/webp",
  ZIP = "application/zip",
  IDML = "application/vnd.adobe.indesign-idml-package",
  XML = "text/xml",
}
